import React, {Component} from 'react';
import { Link, Redirect } from 'react-router-dom';
import api from '../../services/api';
import {Container, Atencao} from './styles';
import Alerta from '../../assets/icones/icon_alert-triangle.svg';
import {FiChevronDown, FiChevronLeft, FiChevronRight} from 'react-icons/fi';
import {Radio} from '@material-ui/core';
import {Switch} from 'antd';
import '../../css/antd.css';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Modal from 'react-modal';
import ModalHorario from './modalHorario';
import ModalDias from './modalDias';
import {CgTrash} from 'react-icons/cg';
import moment from 'moment';
import 'moment/locale/pt-br';
import Axios from 'axios';
import Relogio from '../../assets/emojis/relogio/relogio@3x.png'

import { toast, Slide, ToastContainer } from 'react-toastify';
import '../../css/ReactToastify.css';
import { IoMdCloseCircle, IoMdCheckmarkCircle } from 'react-icons/io';
moment.locale('pt-br');

const theme = createMuiTheme({
    palette: {
      primary: { main: '#c22027' },
      secondary: { main: '#11cb5f' },
    }, 
  });

  const customStyles = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '969px',
        height: '100%',
        maxHeight: '536px'
      }
  };

  const customStylesDias = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '969px',
        height: '100%',
        maxHeight: '836px'
      }
  };

  const customStylesMobile = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        height: `100vh`,
      }
  };

  const customStylesMobileDias = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        height: `100vh`,
      }
  };

  const ano = new Date().getFullYear();
export default class Horarios extends Component {

    constructor(props) {
        super(props);
        this.tab1 = React.createRef();
        this.tab2 = React.createRef();
        this.state = {
            primarios: [],
            secundarios: [],
            diasFechados: [],
            feriados: [],
            nacionais: [],
            addFeriado: [],
            delFeriado: [],
            tabContent: [
                {tab: 'Janeiro', key: '0'},
                {tab: 'Fevereiro', key: '1'},
                {tab: 'Março', key: '2'},
                {tab: 'Abril', key: '3'},
                {tab: 'Maio', key: '4'},
                {tab: 'Junho', key: '5'},
                {tab: 'Julho', key: '6'},
                {tab: 'Agosto', key: '7'},
                {tab: 'Setembro', key: '8'},
                {tab: 'Outubro', key: '9'},
                {tab: 'Novembro', key: '10'},
                {tab: 'Dezembro', key: '11'},
            ],
            turnos: false,
            alerta: false,
            modalHorario: false,
            modalDias: false,
            qualTurno: '',
            id: '',
            carregou: false,
            windowWidth: window.innerWidth,
            defaultTab1: String(moment.utc(new Date()).month()),
            defaultTab2: String(moment.utc(new Date()).month()),
            seta11: 'i',
            seta12: 'i',
            seta21: 'i',
            seta22: 'i',
            token: null,
            redirect: null,
            superUser: null,
            permission: [],
            saved: false,
            saved2: false
        }
    }

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
        this.locateScroll1();
        this.locateScroll2();
    }

    async componentDidMount() {
        toast.configure();
        Modal.setAppElement('body');
        const token = await localStorage.getItem('@jwt');
        const isSuser = await localStorage.getItem('@internal');
        this.setState({token})
        if(isSuser) {
            const permissions = await JSON.parse(localStorage.getItem('@suser'));
            this.setState({superUser: true, permission: permissions.configuracoes})
        }
        if(this.state.superUser) {
            if(this.state.permission !== 0) {
                await this.getDiasFechados();
                await this.getPrimario();
                await this.getSecundario();
                await this.getFeriados();
            }
        } else {
            await this.getDiasFechados();
            await this.getPrimario();
            await this.getSecundario();
            await this.getFeriados();
        }
        if (this.state.carregou) {
            window.addEventListener("resize", this.handleResize);
            this.locateScroll1();
            this.locateScroll2();
            document.getElementById("tab1").addEventListener('scroll', this.handleScroll);
            document.getElementById("tab2").addEventListener('scroll', this.handleScroll);
        }
    }
    //126.25
    locateScroll2() {
        var div = document.getElementById("tab2");
        switch (this.state.defaultTab2) {
            case '1':
                this.scroll2(1)
                break;
            case '2':
                this.scroll2(0.083 * div.scrollWidth)
            break;
            case '3':
                this.scroll2(0.163 * div.scrollWidth)
                break;
            case '4':
                this.scroll2(0.25 * div.scrollWidth)
                break;
            case '5':
                this.scroll2(0.333 * div.scrollWidth)
                break;
            case '6':
                this.scroll2(0.413 * div.scrollWidth)
                break;
            case '7':
                this.scroll2(0.5 * div.scrollWidth)
                break;
            case '8':
                this.scroll2(0.583 * div.scrollWidth)
                break;
            case '9':
                this.scroll2(0.666 * div.scrollWidth)
                break;
            case '10':
                this.scroll2(0.75 * div.scrollWidth)
                break;
            case '11':
                this.scroll2(div.scrollWidth)
                break;
            default:
                break;
        }
    }
    locateScroll1() {
        var div = document.getElementById("tab1");
        switch (this.state.defaultTab1) {
            case '1':
                this.scroll1(1)
                break;
            case '2':
                this.scroll1(0.083 * div.scrollWidth)
            break;
            case '3':
                this.scroll1(0.163 * div.scrollWidth)
                break;
            case '4':
                this.scroll1(0.25 * div.scrollWidth)
                break;
            case '5':
                this.scroll1(0.333 * div.scrollWidth)
                break;
            case '6':
                this.scroll1(0.413 * div.scrollWidth)
                break;
            case '7':
                this.scroll1(0.5 * div.scrollWidth)
                break;
            case '8':
                this.scroll1(0.583 * div.scrollWidth)
                break;
            case '9':
                this.scroll1(0.666 * div.scrollWidth)
                break;
            case '10':
                this.scroll1(0.75 * div.scrollWidth)
                break;
            case '11':
                this.scroll1(div.scrollWidth)
                break;
        
            default:
                break;
        };
    }

    handleScroll = () => {
        this.setState({
            seta11: 'i',
            seta12: 'i',
            seta21: 'i',
            seta22: 'i'
        })
        var div1 = document.getElementById("tab1");
        var div2 = document.getElementById("tab2");
        if (div1.scrollLeft <= 1 && div1 !== null) {
            this.setState({seta11: 'i-close'})
        }
        if ((div1.offsetWidth + div1.scrollLeft) >= div1.scrollWidth - 1 && div1 !== null) {
            this.setState({seta12: 'i-close'})
        }
        if (div2.scrollLeft <= 1 && div2 !== null) {
            this.setState({seta21: 'i-close'})
        }
        if ((div2.offsetWidth + div2.scrollLeft) >= div2.scrollWidth - 1 && div2 !== null) {
            this.setState({seta22: 'i-close'})
        }
    }

    async componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize, false)
        var tab1 = document.getElementById("tab1");
        var tab2 = document.getElementById("tab2");
        if (tab1 !== null && tab2 !== null) {
            tab1.removeEventListener('scroll', this.handleScroll, false);
            tab2.removeEventListener('scroll', this.handleScroll, false); 
        }
    }

    async getDiasFechados() {
        try {
            api.get('api/restauranteconfigs/listaferiados',{
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }
        ).then(async res => {
            console.log(res.data.feriados);
                await this.setState({
                diasFechados: res.data.feriados
            })
        }).catch(async e => {
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                        await localStorage.removeItem('@jwt');
                        await localStorage.removeItem('@user');
                        await localStorage.removeItem('@rest');
                        await localStorage.removeItem('@uf');
                        await localStorage.removeItem('@internal');
                        await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            });
        } catch (error) {
            console.log(error.data);
        }
    }

    async getNacionais() {
        try {
            await api.get('api/restauranteconfigs/nacionais', {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(async res => {
                await this.setState({
                    nacionais: res.data.feriados
                })
            }).catch(async e => {
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                        await localStorage.removeItem('@jwt');
                        await localStorage.removeItem('@user');
                        await localStorage.removeItem('@rest');
                        await localStorage.removeItem('@uf');
                        await localStorage.removeItem('@internal');
                        await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            });
            
        } catch (error) {
            console.log(error.data);
        }
    }
    async getPrimario() {
        try {
            api.get('api/restauranteconfigs/horarioPrimario', {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(async res => {
                let primarios = res.data.horariosPrimarios;
                for (let i = 0; i < primarios.length; i++) {
                    if ((primarios[i].hora_inicial && primarios[i].hora_final) === '00:00:00') {
                        primarios[i].ativo = false;
                    }
                }
                await this.setState({primarios});
            }).catch(async e => {
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                        await localStorage.removeItem('@jwt');
                        await localStorage.removeItem('@user');
                        await localStorage.removeItem('@rest');
                        await localStorage.removeItem('@uf');
                        await localStorage.removeItem('@internal');
                        await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            });
            
        } catch (error) {
            console.log(error.data)
        }
    }

    async getSecundario() {
        try {
            api.get('api/restauranteconfigs/horarioSecundario', {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(async res => {
                let secundarios = res.data.horariosSecundarios;
                for (let i = 0; i < secundarios.length; i++) {
                    if ((secundarios[i].hora_inicial && secundarios[i].hora_final) === '00:00:00') {
                        secundarios[i].ativo = false;
                    }
                }
                for (let j = 0; j < secundarios.length; j++) {
                    if (secundarios[j].ativo === true) {
                        await this.setState({
                            turnos: true,
                        });
                        break;
                    }
                }
                await this.setState({
                    secundarios,
                    carregou: true
                }); 
            }).catch(async e => {
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                        await localStorage.removeItem('@jwt');
                        await localStorage.removeItem('@user');
                        await localStorage.removeItem('@rest');
                        await localStorage.removeItem('@internal');
                        await localStorage.removeItem('@uf');
                        await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            });
            
        } catch (error) {
            console.log(error.data);
        }
    }

    async handleFechadoAberto(tipo, semana, fechado) {
        let prim = this.state.primarios;
        let secun = this.state.secundarios;
        switch (tipo) {
            case 0:
                for (let i = 0; i < prim.length; i++) {
                    if (prim[i].semana === semana) {
                        prim[i].ativo = !prim[i].ativo

                        if(fechado == true){
                            prim[i].hora_inicial = '00:00:00'
                            prim[i].hora_final = '00:00:00'
                        }
                    }
                }
                this.setState({
                    primarios: prim,
                    saved: true
                });
                break;
            case 1:
                for (let i = 0; i < secun.length; i++) {
                    if (secun[i].semana === semana) {
                        secun[i].ativo = !secun[i].ativo

                        if(fechado == true){
                            secun[i].hora_inicial = '00:00:00'
                            secun[i].hora_final = '00:00:00'
                        }
                    }
                }
                this.setState({
                    secundarios: secun,
                    saved: true
                });
                break;
            default:
                break;
        }
    }

    success = () => {
        toast.dismiss();
        const ToastSuccess = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCheckmarkCircle color="#51db74" size={28}/>
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#5b8e3e",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>As alterações foram salvas com sucesso.</span>
                </div>
            </div>
        );
        toast.success(<ToastSuccess />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide,
        });
    }
    error = () => {
        toast.dismiss();
        const ToastError = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCloseCircle color="#d2252e" size={28}/>
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#983236",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>Ocorreu um erro. Tente novamente mais tarde.</span>
                </div>
            </div>
        );
        toast.error(<ToastError />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide
        });
    }

    async subHorarios() {
        let secun = this.state.secundarios;
        if (this.state.turnos === false) {
            for (let i = 0; i < secun.length; i++) {
                secun[i].ativo = false
            }
            this.setState({
                secundarios: secun
            })
        }
        try {
            api.put('/api/restauranteconfigs/mudarHorarios', {
                horariosPrimarios: this.state.primarios,
                horariosSecundarios: this.state.secundarios
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(async res => {
                this.success();
                this.setState({ saved: false })
            }).catch(async e => {
                this.error();
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                        await localStorage.removeItem('@jwt');
                        await localStorage.removeItem('@user');
                        await localStorage.removeItem('@rest');
                        await localStorage.removeItem('@internal');
                        await localStorage.removeItem('@uf');
                        await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            });
            
        } catch (error) {
            console.log(error.data);
        }
    }

    async salvar(id, turno, entrada, saida) {
        let prim = this.state.primarios;
        let secun = this.state.secundarios;
        switch (turno) {
            case 'primeiro':
                for (let i = 0; i < prim.length; i++) {
                    if (prim[i].id === id) {
                        prim[i].hora_inicial = `${entrada}:00`;
                        prim[i].hora_final = `${saida}:00`
                    }
                }
                this.setState({
                    primarios: prim,
                    saved: true
                });
                break;
            case 'segundo':
                for (let i = 0; i < secun.length; i++) {
                    if (secun[i].id === id) {
                        secun[i].hora_inicial = `${entrada}:00`;
                        secun[i].hora_final = `${saida}:00`;
                    }
                }
                this.setState({
                    secundarios: secun,
                    saved: true
                });
                break;
            default:
                break;
        }
        this.setState({modalHorario: false})
    }

    compareValues(key, order = 'asc') {
        return function innerSort(a, b) {
          if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            // property doesn't exist on either object
            return 0;
          }
      
          const varA = (typeof a[key] === 'string')
            ? a[key].toUpperCase() : a[key];
          const varB = (typeof b[key] === 'string')
            ? b[key].toUpperCase() : b[key];
      
          let comparison = 0;
          if (varA > varB) {
            comparison = 1;
          } else if (varA < varB) {
            comparison = -1;
          }
          return (
            (order === 'desc') ? (comparison * -1) : comparison
          );
        };
      }

      controllerModal(estado){
        this.setState({
            modalHorario: !estado,
        });
      }

      controllerModalDias(estado){
        this.setState({
            modalDias: !estado,
        });
      }

      openModalHorario(turno, id) {
        this.setState({
            modalHorario: true,
            qualTurno: turno,
            id: id
        });
      }

    scroll1 = (scrollOffset) => {
        if (this.tab1.current.scrollLeft !== null) {
            this.tab1.current.scrollLeft += scrollOffset;
        }
      };
    
    scroll2 = (scrollOffset) => {
        if (this.tab2.current.scrollLeft !== null) {
            this.tab2.current.scrollLeft += scrollOffset;
        }
    };

    async deletarFeriado(id) {
        let array = this.state.diasFechados;
        try {
            api.delete(`api/restauranteconfigs/deletaferiado/${id}`, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(async res => {
                for (let i = 0; i < array.length; i++) {
                    if (array[i].id === id) {
                        array.splice(i, 1);
                    }
                }
                this.setState({
                    diasFechados: array
                });
                this.success();
            }).catch(async e => {
                this.error();
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                        await localStorage.removeItem('@jwt');
                        await localStorage.removeItem('@user');
                        await localStorage.removeItem('@rest');
                        await localStorage.removeItem('@internal');
                        await localStorage.removeItem('@uf');
                        await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            });
            
        } catch (error) {
            console.log(error.data);
        }
    }

    removeAcento (text) {                                                       
            text = text.replace(new RegExp('[ÁÀÂÃ]','gi'), 'a');
            text = text.replace(new RegExp('[ÉÈÊ]','gi'), 'e');
            text = text.replace(new RegExp('[ÍÌÎ]','gi'), 'i');
            text = text.replace(new RegExp('[ÓÒÔÕ]','gi'), 'o');
            text = text.replace(new RegExp('[ÚÙÛ]','gi'), 'u');
            text = text.replace(new RegExp('[Ç]','gi'), 'c');
            return text;                 
        }

    async getFeriados() {
        await this.getNacionais();
        const estado = await localStorage.getItem('@uf');
        const rest = await JSON.parse(localStorage.getItem('@rest'));
        const city = rest.cidade.nome;
        const formated = city.replace(' ', '_');
        const cidade = this.removeAcento(formated);
        try {
            let array = [];
            const feriados = await Axios.get(`https://api.calendario.com.br/?json=true&ano=${ano}&estado=${estado}&cidade=${cidade}&token=YW5kcmV5Z2lsLmRiQGdtYWlsLmNvbSZoYXNoPTI4Nzc2NTYy`);
            for (let i = 0; i < feriados.data.length; i++) {
                const dataArray = feriados.data[i].date.split('/');
                const timestamp = `${dataArray[2]}-${dataArray[1]}-${dataArray[0]}`;
                if (feriados.data[i].type_code !== '9' && feriados.data[i].type_code !== '4') {
                    array.push({data: timestamp, descricao: feriados.data[i].name, check: true});
                }
            }
            let sorted_arr = array.slice().sort();
            // (slice é pra clonar o array, assim ele não é modificado)
            let results = [];
            for (let i = 0; i < sorted_arr.length - 1; i++) {
                if (sorted_arr[i + 1].data === sorted_arr[i].data) {
                    results.push(sorted_arr[i]);
                }
            }// acha os feriados repetidos
            if (!!results) {
                for (let i = 0; i < results.length; i++) {
                    for (let j = 0; j < array.length; j++) {
                        if (results[i].data === array[j].data) {
                            array.splice(j, 1)
                        }
                    }
                }
            }// remove os feriados repetidos
            for (let i = 0; i < array.length; i++) {
                for (let j = 0; j < this.state.nacionais.length; j++) {
                    const timestamp = this.state.nacionais[j].data.substr(0, 10);
                    if (array[i].data === timestamp) {
                        array[i].check = false;
                        array[i].id = this.state.nacionais[j].id;
                    }
                }
            }
            this.setState({
                feriados: array
            })
        } catch (error) {
            console.log(error.data);
        }
    }

    async handleFeriado(check, data, descricao, id) {
        let add = this.state.addFeriado;
        let del = this.state.delFeriado;
        let feriado = this.state.feriados;
        for (let i = 0; i < feriado.length; i++) {
            if (feriado[i].data === data) {
                feriado[i].check = !check
            }
        }
        this.setState({
            feriados: feriado
        });
        if (check) {
            if (!id) {
                add.push({data: data, descricao: descricao});
            } else {
                for (let i = 0; i < del.length; i++) {
                    if (del[i].data === data) {
                        del.splice(i, 1);
                    }
                }  
            }
        } else {
            if (id) {
                del.push({data: data, id: id});
            } else {
                for (let i = 0; i < add.length; i++) {
                    if (add[i].data === data) {
                        add.splice(i, 1);
                    }
                }
            }        
        }
        this.setState({
            addFeriado: add,
            delFeriado: del,
            saved2: true
        });
    }

    async submitNacionais() {
        const criaNacionais = this.state.addFeriado;
        const deletaNacionais = this.state.delFeriado;
        try {
            await api.post('api/restauranteconfigs/nacional', {
                criaNacionais,
                deletaNacionais
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(async res => {
                this.success();
                this.setState({ saved2: false });
            }).catch(async e => {
                this.error();
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                        await localStorage.removeItem('@jwt');
                        await localStorage.removeItem('@user');
                        await localStorage.removeItem('@rest');
                        await localStorage.removeItem('@internal');
                        await localStorage.removeItem('@uf');
                        await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            });
        } catch (error) {
            console.log(error.data);
        }
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to="/login"/>
        }
    return(
        this.state.superUser && this.state.permission === 0 ? (
            <Container>
                    <h1 style={{
                        fontFamily: 'Montserrat',
                        fontSize: 18,
                        fontWeight: 600
                    }}>Você não possui permissão para visualizar esta página.</h1>
                </Container>
        ) : (
        <Container>
            <ToastContainer limit={1} />
            <Modal
                isOpen={this.state.modalHorario}
                // onAfterOpen={this.controllerModal(this.state.isOpen)}
                onRequestClose={() => this.controllerModal(this.state.modalHorario)}
                shouldCloseOnEsc={false}
                shouldCloseOnOverlayClick={false}
                closeTimeoutMS={100}
                style={this.state.windowWidth > 600 ? customStyles : customStylesMobile}
                contentLabel="Modal"
                >
                        <ModalHorario 
                            salvar={(id, turno, entrada, saida) => this.salvar(id, turno, entrada, saida)}
                            id={this.state.id}
                            turno={this.state.qualTurno}
                            closeModal={() => this.controllerModal(this.state.modalHorario)}/>
                </Modal>
            <Modal
            isOpen={this.state.modalDias}
            // onAfterOpen={this.controllerModal(this.state.isOpen)}
            onRequestClose={() => this.controllerModalDias(this.state.modalDias)}
            shouldCloseOnEsc={false}
            shouldCloseOnOverlayClick={false}
            closeTimeoutMS={100}
            style={this.state.windowWidth > 600 ? customStylesDias : customStylesMobileDias}
            contentLabel="Modal"
            >
                    <ModalDias
                        success={() => this.success()}
                        error={() => this.error()}
                        reload={() => this.getDiasFechados()}
                        token={this.state.token}
                        closeModal={() => this.controllerModalDias(this.state.modalDias)}/>
                </Modal>
            {this.state.carregou ?
        <>
        <div className="div-pai">
            <div className="div-rota">

            <Link 
                style={{ textDecoration: 'none' }}
                to={'/'}>
                <span
                    className="rotas" >
                    Início
                </span>
            </Link>

            <span className="rotas"> {'>'} </span>

            <Link 
                style={{ textDecoration: 'none' }}
                to={'/configuracoes'}>
                <span
                    className="rotas">
                    Configurações
                </span>
            </Link>

            <span className="rotas"> {'>'} </span>

            <Link 
                style={{ textDecoration: 'none' }}
                to={'/configuracoes/horarios-de-funcionamento'}>
                <span> 
                    Horário de funcionamento
                </span>
            </Link>

            </div>

            <img alt="" className="emoji" src={Relogio} />

            <h1>Horário de funcionamento</h1>

            <h5 className="descricao">Escolha os horários de funcionamento da sua loja no aplicativo.</h5>

            <Atencao open={this.state.alerta}>
                <div className="box" 
                    //onClick={() => this.setState({alerta: !this.state.alerta})}
                >
                    <div className="left">
                        <img alt="" src={Alerta} className="alerta"/>
                        <h5>Atenção</h5>
                    </div>
                    {/* <FiChevronDown color={'#000000'} size={24} className="chevron"/> */}
                </div>

                {/* { this.state.alerta ?  */}
                <div className="textos">
                    <ul>
                        <li>Não é possível configurar o horário de abrir posterior ao horário de fechar.</li>
                        <li>Os horários são definidos por dia, ou seja, inicia às 00:00h e finaliza às 23:59h.</li>
                        <li>Para configurar um turno que acabe no dia seguinte, configure nos horários adicionais no dia seguinte correspondente iniciando às 00:00h</li>
                        <li>No segundo turno verifique os horários já em vigor e configure conforme for disponível.</li>
                    </ul>
                </div>
                {/* : null} */}
            </Atencao>

            <hr />

            <div className="turnos">
                <h2>Seu restaurante trabalha com quantos turnos?</h2>
                <label className={this.state.turnos ? 'normal' : 'selected'}>
                <MuiThemeProvider theme={theme}>
                    <Radio 
                        size='small'
                        color="primary"
                        checked={this.state.turnos ? false : true}
                        onChange={
                            () => this.state.superUser ? 
                                    this.state.permission === 2 ? this.setState({ turnos: !this.state.turnos }) : null 
                                    : this.setState({ turnos: !this.state.turnos })
                        }
                    />
                </MuiThemeProvider>
                    <span className="texto">1 turno</span>
                    </label>
                <label className={this.state.turnos ? 'selected': 'normal'}>
                <MuiThemeProvider theme={theme}>
                    <Radio
                        size='small'
                        color="primary"
                        onChange={
                            () => this.state.superUser ? 
                                    this.state.permission === 2 ? this.setState({ turnos: !this.state.turnos }) : null 
                                    : this.setState({ turnos: !this.state.turnos })
                        }
                        checked={this.state.turnos ? true : false}
                    />
                </MuiThemeProvider>
                    <span className="texto">2 turnos</span>
                    </label>
            </div>

            <div className="horarios">
                {this.state.primarios.sort(this.compareValues('semana')).map(item => (
                        <div key={item.id} className="horario" >
                        <h4>{item.dia}</h4>
                        <div 
                            onClick={
                                item.ativo ? 
                                () => this.state.superUser ? 
                                    this.state.permission === 2 ? this.openModalHorario('primeiro', item.id) : null 
                                    : this.openModalHorario('primeiro', item.id)
                                : null
                            }
                            className={item.ativo ? "turno-aberto" : "turno-fechado"}>
                            <div className="left">
                                <h5>1º Turno</h5>
                                <h4>{(item.hora_inicial).substr(0, 5)} - {(item.hora_final).substr(0, 5)}</h4>
                            </div>
                            <FiChevronDown color={'#000000'} size={24} className="chevron"/>
                        </div>
                        
                        <label className="aberto-fechado">
                            <Switch
                                onChange={
                                    () => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleFechadoAberto(0, item.semana, item.ativo) : null 
                                    : this.handleFechadoAberto(0, item.semana, item.ativo)
                                }
                                defaultChecked={item.ativo}
                                checked={item.ativo}
                            />
                            {console.log(item.ativo)}
                            <h4>{item.ativo ? 'Aberto' : 'Fechado'}</h4>
                        </label>
                        { this.state.turnos ? 
                            <>
                            {this.state.secundarios.sort(this.compareValues('semana')).map(item2 => (
                                <>
                            {item.semana === item2.semana ?
                                <>
                            <div
                                key={item2.semana}
                                onClick={
                                    item2.ativo ?
                                    () => this.state.superUser ? 
                                    this.state.permission === 2 ? this.openModalHorario('segundo', item2.id) : null 
                                    : this.openModalHorario('segundo', item2.id) 
                                    : null
                                } 
                                className={item2.ativo ? "turno-aberto" : "turno-fechado"}>
                                <div className="left">
                                    <h5>2º Turno</h5>
                                    <h4>{(item2.hora_inicial).substr(0, 5)} - {(item2.hora_final).substr(0, 5)}</h4>
                                </div>
                                <FiChevronDown color={'#000000'} size={24} className="chevron"/>
                            </div>

                        <label className="aberto-fechado">
                            <Switch
                                onChange={
                                    () => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleFechadoAberto(1, item2.semana, item2.ativo) : null 
                                    : this.handleFechadoAberto(1, item2.semana, item2.ativo)
                                }
                                defaultChecked={item2.ativo}
                                checked={item2.ativo}
                            />
                            <h4>{item2.ativo ? 'Aberto' : 'Fechado'}</h4>
                        </label>
                                </>
                                : null
                            }
                            </>
                            ))}
                            </>
                            : null
                        }
                  </div> 
                ))}
            </div>

            {this.state.superUser ? (
                                this.state.permission === 2 ? (
                                    this.state.saved && (
                                        <div className="botao">
                                        <button
                                            className="salvar" 
                                            onClick={() => this.subHorarios()}>Salvar alterações</button>
                                        </div>
                                    )
                                ) : null
                            ) : (
                                this.state.saved && (
                                    <div className="botao">
                                    <button
                                        className="salvar" 
                                        onClick={() => this.subHorarios()}>Salvar alterações</button>
                                    </div>
                                )
                            )}

            <hr className="linha"/>

            <div className="dias-fechados">
                <h2>Dias fechados</h2>
            
            <div className="tabs">
            <div 
                id="tab1"
                ref={this.tab1}
                className="tab">
                {this.state.tabContent.map(item => (
                        <button 
                            key={item.key}
                            onClick={() => this.setState({defaultTab1: item.key})}
                            className="selecionado">
                            <h1
                            className={this.state.defaultTab1 === item.key ? "selected" : "not-selected"}
                                >{item.tab}</h1>
                        </button>
                    ))
                }
            </div>
                <div className="icones">
                    <button onClick={() => this.scroll1(-200)}>
                    <FiChevronLeft
                        size={24} 
                        className={this.state.seta11}/>
                    </button>
                    <button onClick={() => this.scroll1(200)}>
                    <FiChevronRight
                        size={24}
                        className={this.state.seta12}/>
                    </button>
                </div>
            </div>
            
            <div className="div-dias-fechados">
                {
                    this.state.diasFechados.map(item => (
                        this.state.defaultTab1 === String(moment.utc(item.data).month()) && !item.nacional ?
                        <div className="dia-fechado" key={item.id}>
                            
                            {this.state.superUser ? (
                                this.state.permission === 2 ? (
                                    <button onClick={() => this.deletarFeriado(item.id)}>
                                <CgTrash color="#c01f26" className="i-close" />
                            </button>
                                ) : null
                            ) : (
                                <button onClick={() => this.deletarFeriado(item.id)}>
                                <CgTrash color="#c01f26" className="i-close" />
                            </button>
                            )}
                            <div className="left">
                                <h5>{moment.utc(item.data).format('L')}</h5>
                                <span>{item.descricao}</span>
                            </div>
                        </div>
                        : null
                    ))
                }
            </div>
                            {this.state.superUser ? (
                                this.state.permission === 2 ? (
                                    <div className="botao">
                            <button
                                className="salvar" 
                                onClick={() => this.controllerModalDias(this.state.modalDias)}>Adicionar data</button>
                            </div>
                                ) : null
                            ) : (
                                <div className="botao">
                            <button
                                className="salvar" 
                                onClick={() => this.controllerModalDias(this.state.modalDias)}>Adicionar data</button>
                            </div>
                            )}

            </div>

            <hr className="linha"/>

            <div className="feriados">
                <h2>Feriados de {ano}</h2>

                <div className="tabs">
                <div 
                    id="tab2"
                    ref={this.tab2}
                    className="tab">
                    {
                        this.state.tabContent.map(item => (
                            <button 
                                key={item.key}
                                onClick={() => this.setState({defaultTab2: item.key})}
                                className="selecionado">
                                <h1
                                className={this.state.defaultTab2 === item.key ? "selected" : "not-selected"}
                                    >{item.tab}</h1>
                            </button>
                        ))
                    }
                </div>
                    <div className="icones">
                        <button onClick={() => this.scroll2(-200)}>
                        <FiChevronLeft
                            size={24} 
                            className={this.state.seta21}/>
                        </button>
                        <button onClick={() => this.scroll2(200)}>
                        <FiChevronRight
                            size={24}
                            className={this.state.seta22}/>
                        </button>
                    </div>
                </div>

                <div className="div-feriados">
                    {this.state.feriados.map(item => {
                                return(
                                    this.state.defaultTab2 === String(moment.utc(item.data).month()) ?
                                        <div className="feriado" key={item.data}>
                                            <div className="dia-fechado">
                                                <div className="left">
                                                            <h5>{moment.utc(item.data).format('L')}</h5>
                                                            <span>{
                                                            item.descricao
                                                        }</span>
                                                </div>
                                            </div>
                                            
                                                <label className="aberto-fechado">
                                                    <Switch
                                                        onChange={
                                                            () => this.state.superUser ? 
                                    this.state.permission === 2 ? this.handleFeriado(item.check, item.data, item.descricao, item.id) : null 
                                    : this.handleFeriado(item.check, item.data, item.descricao, item.id)
                                                        }
                                                        defaultChecked={item.check}
                                                        checked={item.check}
                                                    />
                                                    <h4>{item.check ? 'Aberto' : 'Fechado'}</h4>
                                                </label>
                                        </div>
                                    : null
                            )
                        })
                    }
                </div>

            </div>
                            {this.state.superUser ? (
                                this.state.permission === 2 ? (
                                    this.state.saved2 && (
                                        <div className="botao">
                                        <button
                                            className="salvar" 
                                            onClick={() => this.submitNacionais()}>Salvar alterações</button>
                                        </div>
                                    )
                                ) : null
                            ) : (
                                this.state.saved2 && (
                                    <div className="botao">
                                    <button
                                        className="salvar" 
                                        onClick={() => this.submitNacionais()}>Salvar alterações</button>
                                    </div>
                                )
                            )}
        </div>
        </>
        : null}
        </Container>
    ))
    }
}